<router-outlet> </router-outlet>

<!-- Loader component -->
<ng-container *ngIf="loaderService?.loaderType !== buttonLoader">
  <app-loader
      *ngIf="loaderService?.isLoading$ | async"
      [loaderType]="loaderService.loaderType !== buttonLoader ? loaderService.loaderType : ''"
  ></app-loader>
</ng-container>
